<template>
	<div class="index-home">
		<!-- Hero Banner -->
		<div class="hero-section">
			<div class="hero-bg">
				<el-image :src="require('@/static/CodeBuddyAssets/31120_1115/30.png')"></el-image>
			</div>
			<div class="hero-content wow animate__fadeIn" data-wow-duration="0.8s">
				<h1 class="hero-title">{{$t('indexHme.txt1')}}</h1>
				<div class="tit2 f-ct">
					<div class="hero-line left-line"></div>
					<p class="hero-subtitle">
						<span class="gold">{{$t('indexHme.txt2')}}</span>
						<span>{{$t('indexHme.txt3')}}</span>
						<span class="gold">{{$t('indexHme.txt4')}}</span>
						<span>{{$t('indexHme.txt5')}}</span>
					</p>
					<div class="hero-line right-line"></div>
				</div>
			</div>
		</div>
		<!-- 查询区域 -->
		<div class="query-section wow animate__fadeInUp" data-wow-duration="0.8s">
			<div class="query-tabs">
				<span class="tab-item" v-for="(item,index) in lineArr" v-if="index<3" :key="index" :class="{ active: activeTab === item.id }" @click="activeTab = item.id">{{item.name}}</span>
			</div>
			<div class="query-card">
				<div class="query-fields">
					<!-- 起运地 -->
					<div class="field-item">
						<div class="field-top">
							<span class="field-label">{{$t('indexHme.txt6')}}</span>
						</div>
						<div class="field-bottom">
							<el-select v-model="queryForm.warehouseId" :placeholder="$t('indexHme.txt7')" class="field-select">
								<el-option
									v-for="item in originOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
							<el-image class="field-arrow" :src="require('@/static/CodeBuddyAssets/31120_1115/1.svg')"></el-image>
						</div>
					</div>
					<!-- 目的地 -->
					<div class="field-item country-field">
						<div class="field-top">
							<span class="field-label">{{$t('indexHme.txt8')}}</span>
						</div>
						<div class="field-bottom" @click="toggleCountryPanel">
							<span v-if="selectedCountryName" class="field-value">{{selectedCountryName}}</span>
							<span v-else class="field-placeholder">{{$t('indexHme.txt7')}}</span>
							<el-image class="field-arrow" :class="{ 'arrow-up': showCountryPanel }" :src="require('@/static/CodeBuddyAssets/31120_1115/1.svg')"></el-image>
						</div>
						<!-- 目的地弹出选择面板：搜索框 + 字母索引 -->
						<div class="country-panel" v-show="showCountryPanel" @click.stop>
							<div class="country-search">
								<el-input
									v-model="searchKeyword"
									:placeholder="$t('indexHme.txt28')"
									class="country-search-input"
									clearable>
									<i slot="prefix" class="el-icon-search"></i>
								</el-input>
							</div>
							<div class="country-body">
								<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
									<template v-for="group in filteredCountries">
										<div class="country-group" :key="group.letter" :data-letter="group.letter">
											<div class="country-group-title">{{group.letter}}</div>
											<div
												class="country-item"
												:class="{ active: queryForm.countryId === item.value }"
												v-for="item in group.items"
												:key="item.value"
												@click="selectCountry(item)">
												<span class="country-name">{{item.label || item.name}}</span>
											</div>
										</div>
									</template>
									<div v-if="filteredCountries.length === 0" class="country-empty">{{$t('indexHme.txt29')}}</div>
								</div>
								<div class="country-index">
									<span
										v-for="letter in availableLetters"
										:key="letter"
										class="country-index-item"
										:class="{ active: activeLetter === letter }"
										@click="scrollToLetter(letter)">{{letter}}</span>
								</div>
							</div>
						</div>
					</div>
					<!-- 重量 -->
					<div class="field-item">
						<div class="field-top">
							<span class="field-required">*</span>
							<span class="field-label">{{$t('indexHme.txt9')}}(kg)</span>
						</div>
						<div class="field-bottom">
							<el-input v-model="queryForm.weight" type="number" class="field-input" :placeholder="$t('indexHme.txt24')"></el-input>
						</div>
					</div>
					<!-- 长宽高 -->
					<div class="field-item size-field">
						<div class="field-top">
							<span class="field-required">*</span>
							<span class="field-label">{{$t('indexHme.txt10')}}(cm)</span>
						</div>
						<div class="field-bottom size-inputs">
							<el-input v-model="queryForm.length" type="number" class="size-input" :placeholder="$t('indexHme.txt25')"></el-input>
							<el-input v-model="queryForm.width" type="number" class="size-input" :placeholder="$t('indexHme.txt26')"></el-input>
							<el-input v-model="queryForm.height" type="number" class="size-input" :placeholder="$t('indexHme.txt27')"></el-input>
						</div>
					</div>
					<div class="query-btn" @click="handleQuery">{{$t('indexHme.txt11')}}</div>
				</div>
			</div>
		</div>
		<!-- 业务流程 -->
		<div class="section-title wow animate__fadeInUp" data-wow-duration="0.8s">
			<h2>{{$t('indexHme.txt12')}}</h2>
			<p>{{$t('indexHme.txt13')}}</p>
			<el-image class="title-line" :src="require('@/static/CodeBuddyAssets/31120_1115/5.svg')"></el-image>
		</div>
		<div class="process-section">
			<div class="process-grid">
				<div v-for="(item, index) in processItems" :key="index"
					class="process-card wow animate__fadeInUp"
					:data-wow-delay="(index % 4) * 0.1 + 's'"
					:data-wow-duration="0.6 + 's'">
					<span class="card-num">{{ item.num }}</span>
					<el-image class="card-img" :src="require('@/static/CodeBuddyAssets/31120_1115/' + item.img + '.png')"></el-image>
					<p class="card-title">{{ item.title }}</p>
					<p class="card-desc" v-html="item.desc"></p>
				</div>
			</div>
		</div>
		<!-- 我们的优势 -->
		<div class="section-title wow animate__fadeInUp" data-wow-duration="0.8s">
			<h2>{{$t('indexHme.txt14')}}</h2>
			<p>{{$t('indexHme.txt15')}}</p>
			<el-image class="title-line" :src="require('@/static/CodeBuddyAssets/31120_1115/5.svg')"></el-image>
		</div>
		<div class="advantage-section wow animate__fadeInUp" data-wow-duration="0.8s">
			<div class="adv-left">
				<div class="adv-left-bg">
				<el-image :src="require('@/static/CodeBuddyAssets/31120_1115/39.png')"></el-image>
				</div>
			<el-image class="adv-left-icon" :src="require('@/static/CodeBuddyAssets/31120_1115/6.svg')"></el-image>
				<p class="adv-left-title">{{$t('indexHme.txt16')}}</p>
				<p class="adv-left-desc">{{$t('indexHme.txt17')}}</p>
			</div>
			<div class="adv-right">
				<div class="adv-grid">
					<div v-for="(item, index) in advantageItems" :key="index"
						class="adv-item"
						:class="index>2?'nbb':''">
						<div class="f-ct">
							<el-image class="adv-icon" :src="require('@/static/CodeBuddyAssets/31120_1115/' + item.icon + '.svg')"></el-image>
							<p class="adv-title">{{ item.title }}</p>
						</div>
						<p class="adv-desc">{{ item.desc }}</p>
						<el-image v-if="item.extraImg" class="adv-extra" :src="require('@/static/CodeBuddyAssets/31120_1115/' + item.extraImg + '.svg')"></el-image>
					</div>
				</div>
			</div>
		</div>
		<!-- 国际物流资讯 -->
		<div class="section-title wow animate__fadeInUp" data-wow-duration="0.8s">
			<h2>{{$t('indexHme.txt18')}}</h2>
			<p>{{$t('indexHme.txt19')}}</p>
			<el-image class="title-line" :src="require('@/static/CodeBuddyAssets/31120_1115/5.svg')"></el-image>
		</div>
		<div class="news-section wow animate__fadeInUp" data-wow-duration="0.8s">
			<div class="news-left">
				<div class="news-main-card">
					
					<el-carousel height="5.98rem" @change="bannerC" ref="carousel" arrow="never" :loop="true" indicator-position="none" :autoplay="false">
						<el-carousel-item v-for="item in indexArr">
							<div style="height: 5.98rem;">
								<el-image class="news-main-img" :src="item.bannerPicture"></el-image>
								<div class="news-main-overlay"></div>
								<div class="news-video-info">
									<p class="video-title">{{item.title}}</p>
									<div class="video-meta">
										<el-image class="play-icon" :src="require('@/static/CodeBuddyAssets/31120_1115/24.svg')"></el-image>
										<span class="video-time">03:26</span>
									</div>
								</div>
								<div class="news-main-content">
									<p class="news-main-text">{{item.title}}</p>
									<p class="news-main-desc line3">{{item.descriptions}}</p>
									<div class="news-detail-link" @click="link('/newsDetail',{id:item.id})">
										<span>{{$t('indexHme.txt23')}}</span>
										<el-image :src="require('@/static/CodeBuddyAssets/31120_1115/21.svg')"></el-image>
									</div>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
					
					<div class="news-page-btns">
						<el-image @click="prev" :src="require('@/static/CodeBuddyAssets/31120_1115/23.svg')"></el-image>
						<el-image @click="next" :src="require('@/static/CodeBuddyAssets/31120_1115/22.svg')"></el-image>
					</div>
				</div>
			</div>
			<div class="news-right">
				<div class="news-card" v-for="(item, index) in indexArrTow" :key="index">
					<p class="nc-title line1">{{ item.title }}</p>
					<p class="nc-desc">{{ item.descriptions }}</p>
					<div class="nc-link" @click="link('/newsDetail',{id:item.id})">
						<span>{{$t('indexHme.txt23')}}</span>
						<el-image :src="require('@/static/CodeBuddyAssets/31120_1115/21.svg')"></el-image>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	transportLinelineList,
	countrylist,
	warehouselist,
	freightEstimateLineDetail,
	configbase
} from "/src/api/api.js"
// 国家/地区中文名首字 -> 拼音首字母 映射表（用于字母索引分组，兼容中文国家名）
const CN_FIRST_LETTER = {
	'阿': 'A', '埃': 'A', '爱': 'A', '安': 'A', '澳': 'A', '奥': 'A',
	'巴': 'B', '白': 'B', '保': 'B', '北': 'B', '贝': 'B', '比': 'B',
	'冰': 'B', '波': 'B', '博': 'B', '玻': 'B', '伯': 'B', '不': 'B',
	'布': 'B',
	'赤': 'C',
	'丹': 'D', '德': 'D', '东': 'D', '多': 'D',
	'俄': 'E', '厄': 'E',
	'法': 'F', '菲': 'F', '斐': 'F', '芬': 'F', '佛': 'F',
	'冈': 'G', '刚': 'G', '哥': 'G', '格': 'G', '古': 'G', '圭': 'G',
	'哈': 'H', '海': 'H', '韩': 'H', '荷': 'H', '黑': 'H', '洪': 'H',
	'几': 'J', '加': 'J', '柬': 'J', '捷': 'J', '津': 'J',
	'喀': 'K', '卡': 'K', '科': 'K', '克': 'K', '肯': 'K', '库': 'K',
	'拉': 'L', '莱': 'L', '老': 'L', '黎': 'L', '立': 'L', '利': 'L',
	'列': 'L', '卢': 'L', '罗': 'L',
	'马': 'M', '毛': 'M', '美': 'M', '蒙': 'M', '孟': 'M', '密': 'M',
	'缅': 'M', '摩': 'M', '莫': 'M', '墨': 'M',
	'纳': 'N', '南': 'N', '尼': 'N', '挪': 'N',
	'帕': 'P', '葡': 'P',
	'日': 'R', '瑞': 'R',
	'萨': 'S', '塞': 'S', '沙': 'S', '圣': 'S', '斯': 'S', '苏': 'S',
	'索': 'S',
	'塔': 'T', '坦': 'T', '汤': 'T', '特': 'T', '突': 'T', '土': 'T',
	'瓦': 'W', '危': 'W', '委': 'W', '文': 'W', '乌': 'W',
	'西': 'X', '希': 'X', '新': 'X', '匈': 'X', '叙': 'X',
	'牙': 'Y', '亚': 'Y', '也': 'Y', '伊': 'Y', '以': 'Y', '意': 'Y',
	'印': 'Y', '英': 'Y', '约': 'Y', '越': 'Y',
	'赞': 'Z', '智': 'Z', '中': 'Z'
}
export default {
	name: 'IndexHome',
	data() {
		return {
			bannerIdx:0,
			// 查询表单数据
			queryForm: {
				warehouseId: '',
				countryId: '',
				weight: '',
				length: '',
				width: '',
				height: ''
			},
			// 运输路线列表
			lineArr:[],
			activeTab: 1,
			// 起运地选项列表
			originOptions: [],
			// 目的地选项列表
			destinationOptions: [],
			// 国家选择面板
			searchKeyword: '',
			showCountryPanel: false,
			activeLetter: '',
			// 首页数据
			indexArr:[],
			indexArrTow:[],
			// 其他
			processItems: [
				{ num: '1', title: '查询价格', desc: '查询专线价格<br/>价格透明化', img: 33 },
				{ num: '2', title: '线上下单', desc: '一键下单<br/>仓库提前预报', img: 31 },
				{ num: '3', title: '仓库集合', desc: '将预报的包裹运输到<br/>指定的发货仓库', img: 32 },
				{ num: '4', title: '转运包裹', desc: '将货物转发<br/>运输到目的地', img: 34 },
				{ num: '5', title: '货物追踪', desc: '线上追踪订单<br/>线上追踪物流状态', img: 38 },
				{ num: '6', title: '货物到港', desc: '货物送到指定港口并<br/>生成货物运提单', img: 37 },
				{ num: '7', title: '尾程派送', desc: '完成最后100米<br/>将货物送到收货地址', img: 36 },
				{ num: '8', title: '完成签收', desc: '货物签收<br/>订单完成', img: 35 },
			],
			advantageItems: [
				{ icon: 10, title: 'VIP级服务', desc: '专属客服 1V1 响应，7×24 小时在线答疑，快速解决运输中任何问题，享受贵宾级服务体验', extraImg: 13 },
				{ icon: 11, title: '快捷操作', desc: '数字化发货界面，一键查价、下单，物流轨迹同步至小程序，随时随地轻松管理订单，节省时间成本。', extraImg: 15 },
				{ icon: 12, title: '智能系统', desc: '引入智能 TMS 物流运输管理系统，实时监控运输节点，智能优化路线，提升运输效率与准确性', extraImg: 17 },
				{ icon: 7, title: '灵活计价', desc: '根据货物重量、体积、路线等提供多元计价方案自动匹配最优成本渠道，为您节省每一分预算。', extraImg: 14 },
				{ icon: 8, title: '渠道多元化', desc: '涵盖海运、空运、陆运等多种运输方式，针对不同需求与预算，提供个性化渠道选择，满足国际贸易场景。', extraImg: 16 },
				{ icon: 9, title: '经验丰富', desc: '十年以上国际物流服务团队，精通海运、空运全流程，成功服务数千家跨境企业，专业可靠值得信赖。', extraImg: 18 },
			],
		}
	},
	computed: {
		// 当前选中目的地名称
		selectedCountryName() {
			const item = this.destinationOptions.find(o => o.value === this.queryForm.countryId)
			return item ? (item.label || item.name) : ''
		},
		// 按首字母分组 + 搜索过滤后的列表
		filteredCountries() {
			const kw = this.searchKeyword.trim().toLowerCase()
			let list = this.destinationOptions
			if (kw) {
				list = list.filter(item => {
					const name = String(item.label || item.name || '').toLowerCase()
					return name.indexOf(kw) > -1
				})
			}
			return this.groupByLetter(list)
		},
		// 字母索引条：基于全部国家（不随搜索变化）
		availableLetters() {
			const set = []
			this.destinationOptions.forEach(item => {
				const l = this.getFirstLetter(item.label || item.name)
				if (set.indexOf(l) === -1) set.push(l)
			})
			return set.sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
		}
	},
	mounted() {
		this.transportLinelineListF()
		this.countrylistF()
		this.warehouselistF()
		this.configbase()
		document.addEventListener('click', this.handleDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick)
	},
	methods: {
		// ===== 国家选择面板相关 =====
		// 切换面板显示状态
		toggleCountryPanel() {
			this.showCountryPanel = !this.showCountryPanel
			if (this.showCountryPanel) {
				this.searchKeyword = ''
				this.activeLetter = ''
			}
		},
		// 选中国家
		selectCountry(item) {
			this.queryForm.countryId = item.value
			this.showCountryPanel = false
			this.searchKeyword = ''
		},
		// 点击字母索引，锚定滚动到对应分组
		scrollToLetter(letter) {
			this.activeLetter = letter
			const listEl = this.$refs.countryList
			if (!listEl) return
			const target = listEl.querySelector(`[data-letter="${letter}"]`)
			if (target) {
				listEl.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
			}
		},
		// 列表滚动时高亮当前所在字母
		onCountryListScroll() {
			const listEl = this.$refs.countryList
			if (!listEl) return
			const scrollTop = listEl.scrollTop
			let current = ''
			listEl.querySelectorAll('[data-letter]').forEach(el => {
				if (el.offsetTop <= scrollTop + 1) {
					current = el.getAttribute('data-letter')
				}
			})
			this.activeLetter = current
		},
		// 提取首字母（兼容英文/中文，无法识别归入 #）
		getFirstLetter(name) {
			if (!name) return '#'
			const first = String(name).trim().charAt(0)
			if (/[a-zA-Z]/.test(first)) return first.toUpperCase()
			if (/[\u4e00-\u9fa5]/.test(first)) {
				return CN_FIRST_LETTER[first] || '#'
			}
			return '#'
		},
		// 按首字母分组
		groupByLetter(list) {
			const groups = {}
			list.forEach(item => {
				const letter = this.getFirstLetter(item.label || item.name)
				if (!groups[letter]) groups[letter] = []
				groups[letter].push(item)
			})
			const letters = Object.keys(groups).sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
			return letters.map(l => ({ letter: l, items: groups[l] }))
		},
		// 点击面板外部关闭
		handleDocumentClick(e) {
			if (!this.showCountryPanel) return
			const field = this.$el.querySelector('.country-field')
			if (field && !field.contains(e.target)) {
				this.showCountryPanel = false
			}
		},
		// 配置信息
		async configbase(){
			var res;
			res = await configbase({});
			if(res.code==200){
				var arr = res.data.articleList
				this.indexArr = [arr[0],arr[1]]
				this.indexArrTow = [arr[2],arr[3],arr[4]]
			}else{this.Tips(res.msg,'error')}
		},
		// 提交
		async handleQuery(){
			this.$store.commit('userMsg/jisuanC',this.queryForm);
			this.link('/freightEstimate')
		},
		// 运输路线列表
		async transportLinelineListF(){
			var res;
			res = await transportLinelineList({});
			if(res.code==200){
				this.lineArr = res.rows
				this.activeTab = res.rows[0].id
			}else{this.Tips(res.msg,'error')}
		},
		// 国家列表(全部启用的)
		async countrylistF(){
			var res;
			res = await countrylist({});
			if(res.code==200){
				var destinationOptions = []
				res.rows.forEach((item)=>{
					destinationOptions.push({
						...item,
						label:item.name,
						value:item.id,
					})
				})
				this.destinationOptions = destinationOptions
			}else{this.Tips(res.msg,'error')}
		},
		// 仓库列表(全部正常的)
		async warehouselistF(){
			var res;
			res = await warehouselist({});
			if(res.code==200){
				var originOptions = []
				res.rows.forEach((item)=>{
					originOptions.push({
						...item,
						label:item.name,
						value:item.id,
					})
				})
				this.originOptions = originOptions
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转至最新资讯列表页
		goToNews() {
			this.$router.push('/latestNews')
		},
		// 轮播切换
		bannerC(e){
			this.bannerIdx = e
		},
		prev(){
			this.$refs.carousel.prev()
		},
		next(){
			this.$refs.carousel.next()
		},
		bannerDian(index){
			this.$refs.carousel.setActiveItem(index)
		},
		scrollToTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		}
	}
}
</script>

<style lang="scss" scoped>
.index-home {
	position: relative;
	width: 100%;
	background: #fff;
	padding-bottom: 2rem;
}
/* ===== Hero ===== */
.hero-section {
	position: relative;
	width: 100%;
	height: 4.00rem;
	.hero-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #0096FF;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.hero-content {
		position: absolute;
		top: 1.12rem;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
		width: 1920px;
	}
	.hero-title {
		font-size: 0.62rem;
		font-weight: 600;
		color: #fff;
		letter-spacing: 2px;
	}
	.tit2{
		justify-content: center;
		.hero-subtitle{
			padding: 0 12px;
		}
	}
	.hero-subtitle {
		margin-top: 0.18rem;
		font-size: 0.20rem;
		font-weight: 500;
		.gold {
			color: #E6CC6D;
		}
		span {
			color: #fff;
		}
	}
	.hero-line {
		transform: translateY(10px);
		width: 0.82rem;
		height: 0.02rem;
		&.left-line {
			background: linear-gradient(90deg, rgba(255,255,255,0) 0%, #fff 100%);
		}
		&.right-line {
			background: linear-gradient(90deg, rgba(255,255,255,0) 0%, #fff 100%);
			transform: rotate(180deg)translateY(-10px);
		}
	}
}
/* ===== 查询区 ===== */
.query-section {
	position: relative;
	width: 14.60rem;
	margin: -1.15rem auto 0;
	z-index: 10;
}
.query-tabs {
	display: flex;
	padding-left: 0.44rem;
	.tab-item {
		color: #fff;
		font-size: 0.17rem;
		font-weight: 500;
		padding: 0.14rem 0.24rem;
		cursor: pointer;
		transition: all 0.3s;
		&.active {
			background: #fff;
			color: #0096FF;
			border-top-left-radius: 0.06rem;
			border-top-right-radius: 0.06rem;
		}
		&:hover:not(.active) {
			opacity: 0.8;
		}
	}
}
.query-card {
	background: #fff;
	box-shadow: 0 0.02rem 0.16rem rgba(0,0,0,0.05);
	border-radius: 0.08rem 0.08rem;
	padding: 0.32rem 0.24rem;
}
.query-fields {
	display: flex;
	align-items: flex-end;
	gap: 0.16rem;
}
.field-item {
	flex: 1;
	min-width: 0;
	border: 0.01rem solid #E2E6E9;
	border-radius: 0.05rem;
	padding: 0.09rem 0.18rem;
	height: 0.69rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	transition: border-color 0.3s, box-shadow 0.3s;
	position: relative;
	&:hover {
		border-color: #0096FF;
		box-shadow: 0 0 0.02rem rgba(0,150,255,0.15);
	}
	.field-top {
		display: flex;
		align-items: center;
		position: absolute;
		background: #fff;
		top: 0;
		padding: 0 0.1rem;
		transform: translateY(-50%);
		.field-icon {
			margin-right: 0.04rem;
		}
		.field-required {
			color: #FC1E0E;
			font-size: 0.14rem;
			font-weight: 500;
		}
		.field-label {
			color: #92969F;
			font-size: 0.14rem;
			font-weight: 500;
		}
	}
	.field-bottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 0.69rem;
		.field-value {
			color: #333;
			font-size: 0.16rem;
			font-weight: 500;
		}
		.field-placeholder {
			color: #BFC6CE;
			font-size: 0.16rem;
			font-weight: 500;
		}
		.field-arrow {
			cursor: pointer;
		}
		/* 下拉选择框样式 */
		.field-select {
			width: 100%;
			padding-left: 4px;
			::v-deep .el-input__inner {
				border: none;
				padding: 0;
				font-size: 0.16rem;
				color: #333;
				background: transparent;
				cursor: pointer;
			}
			::v-deep .el-input__suffix{
				display: none;
			}
			.el-input__suffix {
				.el-select__caret {
					color: #999;
					font-size: 0.12rem;
				}
			}
		}
		/* 文本输入框样式 */
		.field-input {
			flex: 1;
			width: 100%;
			::v-deep .el-input__inner {
				border: none;
				padding: 0;
				padding-left: 8px;
				font-size: 0.16rem;
				color: #333;
				background: transparent;
				caret-color: #0096FF;
				box-shadow: none;
			}
			.el-input__inner::placeholder {
				color: #BFC6CE;
				font-weight: 500;
			}
		}
	}
	.size-inputs {
		display: flex;
		justify-content: space-between;
		gap: 0.12rem;
		.size-input {
			flex: 1;
			min-width: 0;
			::v-deep .el-input__inner {
				border: none;
				padding: 0.06rem 0.06rem;
				font-size: 0.16rem;
				color: #333;
				// text-align: center;
				background: #FAFBFC;
				border-radius: 0.04rem;
				caret-color: #0096FF;
				box-shadow: none;
				transition: background-color 0.3s, box-shadow 0.3s;
			}
			.el-input__inner::placeholder {
				color: #BFC6CE;
				font-weight: 500;
			}
			.is-focus .el-input__inner,
			.el-input:focus .el-input__inner {
				background: #fff;
				box-shadow: 0 0 0.02rem rgba(0,150,255,0.15);
			}
		}
	}
}
.query-btn {
	width: 2.03rem;
	height: 0.70rem;
	background: #0096FF;
	border-radius: 0.05rem;
	color: #fff;
	font-size: 0.18rem;
	font-weight: 500;
	text-align: center;
	line-height: 0.70rem;
	cursor: pointer;
	flex-shrink: 0;
	transition: all 0.3s;
	&:hover {
		background: #33ABFF;
		box-shadow: 0 0.04rem 0.12rem rgba(0,150,255,0.4);
		transform: translateY(-0.02rem);
	}
	&:active {
		background: #0081D9;
		transform: translateY(0);
	}
}
/* ===== 通用标题 ===== */
.section-title {
	text-align: center;
	padding-top: 0.66rem;
	h2 {
		font-size: 0.28rem;
		font-weight: 500;
		color: #333;
	}
	p {
		margin-top: 0.12rem;
		font-size: 0.14rem;
		color: #586274;
	}
	.title-line {
		display: block;
		width: 22px;
		height: 2px;
		margin: 0.10rem auto 0;
	}
}
/* ===== 业务流程 ===== */
.process-section {
	width: 13.46rem;
	margin: 0.44rem auto 0;
}
.process-grid {
	display: grid;
	grid-template-columns: repeat(4, 3.04rem);
	grid-template-rows: repeat(2, 2.26rem);
	gap: 0.42rem 0.46rem;
	justify-content: center;
}
.process-card {
	background: #f6f8fd90;
	border-radius: 0.08rem;
	padding: 0;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.3s, box-shadow 0.3s;
	&:hover {
		transform: translateY(-0.04rem);
		box-shadow: 0 0.08rem 0.24rem rgba(0,0,0,0.08);
	}
	.card-num {
		position: absolute;
		top: 0.16rem;
		left: 0.24rem;
		font-size: 0.90rem;
		font-family: '078-SS Meng Hei Ti', sans-serif;
		font-weight: 400;
		background: linear-gradient(180deg, rgba(102,127,191,1) 0%, rgba(249,250,253,0) 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		line-height: 1;
	}
	.card-img {
		position: absolute;
		top: 0.16rem;
		right: 0;
		width: 1.38rem;
		height: 1.38rem;
		object-fit: contain;
	}
	.card-title {
		position: absolute;
		top: 1.12rem;
		left: 0.30rem;
		font-size: 0.20rem;
		font-weight: 500;
		color: #333;
	}
	.card-desc {
		position: absolute;
		top: 1.50rem;
		left: 0.30rem;
		font-size: 0.16rem;
		color: #A7B8DF;
		font-weight: 400;
		line-height: 1.4;
	}
}
/* ===== 我们的优势 ===== */
.advantage-section {
	display: flex;
	width: 13.46rem;
	margin: 0.44rem auto 0;
}
.adv-left {
	width: 2.92rem;
	height: 3.50rem;
	position: relative;
	flex-shrink: 0;
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.3s;
	&:hover {
		transform: scale(1.02);
	}
	.adv-left-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #0096FF;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.adv-left-icon {
		position: absolute;
		top: 0.32rem;
		left: 0.24rem;
	}
	.adv-left-title {
		position: absolute;
		top: 0.60rem;
		left: 0.24rem;
		color: #fff;
		font-size: 0.32rem;
		font-family: '078-SS Meng Hei Ti', sans-serif;
		font-weight: 400;
	}
	.adv-left-desc {
		position: absolute;
		top: 1.12rem;
		left: 0.24rem;
		right: 0.24rem;
		color: #fff;
		font-size: 0.14rem;
		font-weight: 400;
		line-height: 1.6;
	}
}
.adv-right {
	flex: 1;
	background: #f6fafe90;
	height: 3.50rem;
}
.adv-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
}
.adv-item {
	width: 3.52rem;
	height: 1.77rem;
	padding: 0 0.28rem;
	padding-top: 0.3rem;
	position: relative;
	cursor: pointer;
	border-radius: 0.02rem;
	transition: background 0.3s, box-shadow 0.3s;
	border-bottom: 0.01rem solid #F2F5FF;
	border-right:  0.01rem solid #F2F5FF;
	&:hover {
		background: #fff;
		box-shadow: 0 0.04rem 0.16rem rgba(0,0,0,0.06);
	}
	.adv-icon {
		margin-bottom: 0.06rem;
	}
	.adv-title {
		font-size: 0.18rem;
		font-weight: 600;
		color: #333;
	}
	.adv-desc {
		margin-top: 0.06rem;
		font-size: 0.14rem;
		color: #818793;
		line-height: 1.6;
	}
	.adv-extra {
		margin-top: 0.10rem;
	}
}
.nbr{
	border-right: 0;
}
.nbb{
	border-bottom: 0;
}
/* ===== 国际物流资讯 ===== */
.news-section {
	display: flex;
	gap: 0.24rem;
	width: 13.46rem;
	margin: 0.44rem auto 0;
}
.news-left {
	flex-shrink: 0;
}
.news-main-card {
	width: 9.12rem;
	height: 5.98rem;
	background: linear-gradient(180deg, #F4F5FA 0%, #fff 100%);
	box-shadow: 0 0.04rem 0.30rem 0.02rem #f0f2fb;
	border-radius: 0.08rem;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.3s, box-shadow 0.3s;
	&:hover {
		transform: translateY(-0.04rem);
		box-shadow: 0 0.08rem 0.40rem 0.04rem #E8EAF2;
	}
	.news-main-img {
		width: 8.56rem;
		height: 3.58rem;
		margin: 0.28rem 0 0 0.28rem;
		object-fit: cover;
		border-radius: 0.04rem;
	}
	.news-main-overlay {
		position: absolute;
		top: 0.28rem;
		left: 0.28rem;
		width: 8.56rem;
		height: 3.58rem;
		background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.60) 100%);
		border-radius: 0.04rem;
	}
	.news-video-info {
		position: absolute;
		top: 2.81rem;
		left: 0.52rem;
		.video-title {
			color: #fff;
			font-size: 0.22rem;
			font-weight: 500;
		}
		.video-meta {
			display: flex;
			align-items: center;
			margin-top: 0.06rem;
			.play-icon {
				margin-right: 0.06rem;
			}
			.video-time {
				color: #fff;
				font-size: 0.16rem;
			}
		}
	}
	.news-main-content {
		padding: 0.24rem 0.28rem 0;
		.news-main-text {
			font-size: 0.20rem;
			font-weight: 500;
			color: #333;
		}
		.news-main-desc {
			margin-top: 0.12rem;
			font-size: 0.16rem;
			font-weight: 500;
			color: #6F7A8F;
			line-height: 1.6;
		}
	}
	.news-detail-link {
		display: flex;
		align-items: center;
		margin-top: 0.12rem;
		cursor: pointer;
		span {
			color: #0096FF;
			font-size: 0.16rem;
			font-weight: 500;
		}
		img {
			margin-left: 0.04rem;
		}
		&:hover span {
			text-decoration: underline;
		}
	}
	.news-page-btns {
		position: absolute;
		bottom: 0.18rem;
		right: 0.28rem;
		display: flex;
		gap: 0.08rem;
		z-index: 20;
		img {
			cursor: pointer;
		}
	}
}
.news-right {
	display: flex;
	flex-direction: column;
	gap: 0.30rem;
}
.news-card {
	width: 4.10rem;
	height: 1.80rem;
	background: linear-gradient(180deg, #F4F5FA 0%, #fff 100%);
	box-shadow: 0 0.04rem 0.30rem 0.02rem #F5F6FB;
	border-radius: 0.08rem;
	padding: 0.26rem 0.28rem;
	cursor: pointer;
	transition: all 0.3s;
	&:hover {
		transform: translateY(-0.04rem);
		background: #0096FF;
		box-shadow: 0 0.08rem 0.40rem 0.04rem rgba(0,150,255,0.50);
		.nc-title {
			color: #fff;
		}
		.nc-desc {
			color: rgba(255,255,255,0.85);
		}
		.nc-link span {
			color: #fff;
		}
		.nc-link img {
			filter: brightness(0) invert(1);
		}
	}
	.nc-title {
		font-size: 0.20rem;
		font-weight: 500;
		color: #333;
		transition: color 0.3s;
	}
	.nc-desc {
		margin-top: 0.10rem;
		font-size: 0.16rem;
		font-weight: 500;
		color: #6F7A8F;
		line-height: 1.5;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		transition: color 0.3s;
	}
	.nc-link {
		display: flex;
		align-items: center;
		margin-top: 0.10rem;
		span {
			color: #0096FF;
			font-size: 0.16rem;
			font-weight: 500;
			transition: color 0.3s;
		}
		img {
			margin-left: 0.04rem;
			transition: filter 0.3s;
		}
		&:hover span {
			text-decoration: underline;
		}
	}
}

/* ===== 目的地国家选择面板 ===== */
.country-field {
	overflow: visible;
}
.field-arrow {
	transition: transform 0.3s;
	&.arrow-up {
		transform: rotate(180deg);
	}
}
.country-panel {
	position: absolute;
	top: calc(100% + 0.06rem);
	left: 0;
	width: 7.2rem;
	background: #fff;
	border-radius: 0.08rem;
	box-shadow: 0 0.08rem 0.32rem rgba(0, 0, 0, 0.16);
	z-index: 999;
	padding: 0.16rem;
	box-sizing: border-box;
}
.country-search {
	margin-bottom: 0.12rem;
	.country-search-input {
		::v-deep .el-input__inner {
			height: 0.4rem;
			border: 0.01rem solid #E2E6E9;
			border-radius: 0.04rem;
			padding-left: 0.3rem;
			font-size: 0.14rem;
			color: #333;
		}
		::v-deep .el-input__inner:focus {
			border-color: #0096FF;
		}
		::v-deep .el-input__prefix {
			left: 0.08rem;
			line-height: 0.4rem;
			color: #92969F;
		}
	}
}
.country-body {
	display: flex;
	align-items: flex-start;
}
.country-list {
	flex: 1;
	height: 3.2rem;
	overflow-y: auto;
	padding-right: 0.08rem;
	position: relative;
	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: #ddd;
		border-radius: 2px;
	}
}
.country-group-title {
	font-size: 0.13rem;
	font-weight: 600;
	color: #0096FF;
	padding: 0.06rem 0.1rem;
}
.country-item {
	padding: 0.08rem 0.1rem;
	font-size: 0.14rem;
	color: #333;
	cursor: pointer;
	border-radius: 0.04rem;
	transition: background 0.2s, color 0.2s;
	&:hover {
		background: #F0F7FD;
		color: #0096FF;
	}
	&.active {
		background: #F0F7FD;
		color: #0096FF;
		font-weight: 500;
	}
}
.country-empty {
	text-align: center;
	color: #BFC6CE;
	font-size: 0.14rem;
	padding: 0.4rem 0;
}
.country-index {
	width: 0.36rem;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: 3.2rem;
	overflow-y: auto;
	border-left: 0.01rem solid #F0F0F0;
}
.country-index-item {
	font-size: 0.12rem;
	color: #666;
	cursor: pointer;
	line-height: 1.4;
	padding: 0.01rem 0;
	transition: color 0.2s;
	&:hover,
	&.active {
		color: #0096FF;
		font-weight: 600;
	}
}
</style>
